import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-592aa70e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = ["onClick", "tabindex"]

import { ref, withDefaults } from 'vue';
import { useRouter } from 'vue-router'

export interface TabOption {
  label: string,
  value: string,
  route: string,
}

interface IProps {
  default: string,
  tabs: TabOption[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeNavigationTabs',
  props: {
    default: {},
    tabs: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();

const selectedItem = ref<TabOption>()

const emit = __emit;


const props = __props;

function onChange(option: TabOption) {
  selectedItem.value = option;

  emit('update:modelValue', selectedItem);

  router.push({ path: option.route });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["tab", { active: _unref(router).currentRoute.value.path === tab.route, space: (index + 1) % 2 == 0 }]),
        onClick: ($event: any) => (onChange(tab)),
        role: "tab",
        tabindex: index
      }, _toDisplayString(tab.label), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})